<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{ aLang.c_create }} tin tức</span>
        <span v-if="mData.viewMode == 'update'">{{ aLang.c_update }} tin tức</span>
        <span v-if="mData.viewMode == 'detail'">{{ aLang.c_detail }} tin tức</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="12">
              <el-form-item label="Tên loại câu hỏi" prop="name">
                <el-input
                  type="text"
                  v-model="mData.dataForm.name"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6" style="position: relative;">
              <el-form-item label="Icon" prop="icon">
                <el-input
                  type="text"
                  v-model="mData.dataForm.icon"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
                <div
                  style="position: absolute; height: 30px; width: 30px; text-align: center; line-height: 30px; top: 1px; right: 1px; background-color: #fff;border-top-right-radius: 3px; border-bottom-right-radius: 3px;"
                >
                  <i :class="'fa ' + mData.dataForm.icon"></i>
                </div>
              </el-form-item>
            </b-col>
            <b-col md="6" style="position: relative;">
              <el-button
                type="primary"
                icon="el-icon-search"
                style="margin-top: 32px;"
                @click="mData.dataDefault.showSearchIcon = !mData.dataDefault.showSearchIcon"
              ></el-button>
              <div
                v-show="mData.dataDefault.showSearchIcon"
                style="position: absolute; top: 90%; left: 15; z-index: 9; box-shadow:  4px 7px 8px 0px rgba(0,0,0,0.3);border-radius: 5px;"
              >
                <font-awesome-picker v-on:selectIcon="fn_selectionIcon"></font-awesome-picker>
              </div>
            </b-col>
          </b-row>

          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
            >{{ aLang.c_create }}</el-button>

            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
            >{{ aLang.c_update }}</el-button>

            <el-button @click="fn_go()" type="info" plain>{{ aLang.c_back }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

    <script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import QATypesModel from "./QATypesModel";
import QA_TypeApi from "../../../moduleApi/QA_TypeApi";
import moment from "moment";
import { fontAwesomePicker } from "font-awesome-picker";

export default {
  components: {
    "font-awesome-picker": fontAwesomePicker
  },
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "QATypes",
        dataDefault: {
          showSearchIcon: false
        },
        dataForm: MethodService.copyObject(QATypesModel.dataForm),
        validForm: QATypesModel.validForm
      }
    };
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          let currentUser = MethodService.getCurrentUser();
          let data = MethodService.copyObject(this.mData.dataForm);
          data.name = data.name.trim();
          data.created_time = moment().format();
          data.creator_id = currentUser.id;
          if (type == "create") {
            await QA_TypeApi.create(data);
            this.fn_resetForm();
          }
          if (type == "update") {
            data.id = this.$router.currentRoute.params.id;
            await QA_TypeApi.update(data);
            this.fn_go(-1);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      let res = await QA_TypeApi.findById(id);
      // debugger
      this.mData.dataForm = res.result;
    },
    async fn_initDataDefault() {},

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },
    fn_selectionIcon(icon) {
      this.mData.dataForm.icon = icon.className;
      this.mData.dataDefault.showSearchIcon = false;
    }
  },
  created: function() {
    this.fn_initDataDefault();

    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted: function() {}
};
</script>
    <style scoped>
</style>